// ============================================
// PROFILE SECTION COMPONENT
// ============================================
import { FaUser, FaEnvelope, FaBuilding, FaPhone, FaIdCard, FaFileAlt } from "react-icons/fa"

const ProfileSection = ({ selectedUser }) => {
  const profileFields = [
    { label: "Username", value: selectedUser.username, icon: FaUser },
    { label: "Email", value: selectedUser.email, icon: FaEnvelope },
    { label: "Company Name", value: selectedUser.company_name, icon: FaBuilding },
    { label: "Phone Number", value: selectedUser.phone, icon: FaPhone },
    { label: "GSTIN Number", value: selectedUser.gstin, icon: FaIdCard },
    { label: "PAN Number", value: selectedUser.pan, icon: FaFileAlt },
  ]

  return (
    <div className="profile-tab">
      <div className="section-header">
        <FaUser className="section-icon" />
        <h2>User Profile</h2>
      </div>
      <div className="profile-details">
        {profileFields.map(({ label, value, icon: Icon }) => (
          <div className="profile-field" key={label}>
            <label>
              <Icon className="field-icon" />
              {label}:
            </label>
            <span>{value || "Not provided"}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ProfileSection
